//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { addRole, editRole, duplicateCheck } from '@/api/api';
export default {
  name: "RoleModal",
  data: function data() {
    return {
      title: "操作",
      visible: false,
      roleDisabled: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        roleName: {
          rules: [{
            required: true,
            message: '请输入角色名称!'
          }, {
            min: 2,
            max: 30,
            message: '长度在 2 到 30 个字符',
            trigger: 'blur'
          }]
        },
        roleCode: {
          rules: [{
            required: true,
            message: '请输入角色名称!'
          }, {
            min: 0,
            max: 64,
            message: '长度不超过 64 个字符',
            trigger: 'blur'
          }, {
            validator: this.validateRoleCode
          }]
        },
        description: {
          rules: [{
            min: 0,
            max: 126,
            message: '长度不超过 126 个字符',
            trigger: 'blur'
          }]
        }
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true; //编辑页面禁止修改角色编码

      if (this.model.id) {
        this.roleDisabled = true;
      } else {
        this.roleDisabled = false;
      }

      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'roleName', 'description', 'roleCode', 'sortOrder'));
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(_this2.model, values);
          var obj;
          console.log(formData);

          if (!_this2.model.id) {
            obj = addRole(formData);
          } else {
            obj = editRole(formData);
          }

          obj.then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;

            _this2.close();
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    validateRoleCode: function validateRoleCode(rule, value, callback) {
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback("角色编码不可输入汉字!");
      } else {
        var params = {
          tableName: "sys_role",
          fieldName: "role_code",
          fieldVal: value,
          dataId: this.model.id
        };
        duplicateCheck(params).then(function (res) {
          if (res.success) {
            callback();
          } else {
            callback(res.message);
          }
        });
      }
    }
  }
};